import { PerForDemo0, PerForDemo1, PerForDemo2 } from "..\\..\\..\\..\\content\\blog\\react-pratice-and-performance\\components.js";
import React from 'react';
export default {
  PerForDemo0,
  PerForDemo1,
  PerForDemo2,
  React
};